import { useParams } from 'react-router-dom'
import { projects } from '../projects'
import { ProjectTemplate } from '../components/ProjectTemplate'
import { useMediaQuery } from '@geist-ui/react'

export const Project = (
  props: {
    type: 'graphic' | 'illustration',
  }
) => {
  const { id } = useParams()
  const { type } = props

  const isMdUp = useMediaQuery('md', { match: 'up' })

  const projectsFromMQ = projects(isMdUp)
  const project = id
    ? projectsFromMQ[type][Number(id)]
    : projectsFromMQ[type][1]

  return <ProjectTemplate project={project} />
}
